const MENU_PREFIX = 'M';
const ELEMENT_PREFIX = 'B';
const PURCHASE_PRODUCT_PREFIX = 'S';
const PROCESS_PRODUCT_PREFIX = 'K';

export { MENU_PREFIX, ELEMENT_PREFIX, PURCHASE_PRODUCT_PREFIX, PROCESS_PRODUCT_PREFIX };
